import { Trans } from "@lingui/react";
import { Button } from "@warp-ds/react";
import { Icon } from "../components/Icon.tsx";
import { ScreenReaderSeparator } from "../components/ScreenReaderSeparator.tsx";
import { useValidDealerContext } from "../context/DealerProviderContext.tsx";
import { useTracking } from "../utils/pulseHelper.ts";

export const DeepLinkAction = () => {
  const {
    itemData: { externalItemUrl },
    external: { isPreview },
  } = useValidDealerContext();
  if (externalItemUrl) {
    return <ExternalItem key="external" externalItemUrl={externalItemUrl} isPreview={isPreview} />;
  }
  return null;
};

const ExternalItem = ({ externalItemUrl, isPreview = false }: { externalItemUrl: string; isPreview?: boolean }) => {
  const { trackGoToItem } = useTracking();

  if (isPreview) {
    return (
      <Button data-testid="external-item" fullWidth className="flex items-center whitespace-nowrap md:min-w-[170px]">
        <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
        <ScreenReaderSeparator />
        <Icon name="LinkExternal" className="ml-4" />
      </Button>
    );
  }

  return (
    <Button
      data-testid="external-item"
      fullWidth
      className="flex items-center whitespace-nowrap md:min-w-[170px]"
      href={externalItemUrl}
      target="_blank"
      rel="noopener sponsored"
      onClick={trackGoToItem}
    >
      <Trans id="dealer.actions.deeplink" message="View ad on seller's page" />
      <ScreenReaderSeparator />
      <Icon name="LinkExternal" className="ml-4" />
    </Button>
  );
};
